import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Card, Row, Col, DatePicker, Select, Tooltip, Button, Form, Checkbox, notification, Drawer, Popconfirm } from 'antd'
import { TableComp } from 'sz-react-utils'
import Request, { API_URL } from '../../request'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import moment from 'moment'
import _ from 'lodash'
import { connect } from 'react-redux'
import EditAttendence from '../../components/_utils/editAttendence'
import AddAttendence from '../../components/_utils/addAttendence'
import async from 'async'
import { RightsWrapper } from '../../components/_utils/utils'

const { Option } = Select

const { RangePicker } = DatePicker;

let userCheckBox = {}
let regulariseData = {}


@Form.create()
class EditAttendenceRecord extends Component {
  state = {
    visible: true,
    loading: false,
  }

  componentDidMount() {
    let { record } = this.props
    setTimeout(() => {
      this.props.form.setFieldsValue(record)
    }, 100)
  }

  onClose = () => {
    setTimeout(() => {
      this.props.onClose()
    }, 500)
  }

  handleEditAttendenceSubmit = (e) => {
    const { form, dispatch } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData);
      let data = this.props.record;
      data.loginAt = values.loginAt;
      data.logoutAt = values.logoutAt;
      this.setState({ loading: true })
      let response = await Request.editEmployeeAttendence(data)
      this.setState({ loading: false })
      if (response.success) {
        notification.success({
          message: response.message
        })
      }
      this.onClose()
    })
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue }
    } = this.props
    const inputTypes = {
      fields: [
        {
          label: 'Login At',
          key: 'loginAt',
          type: 'time'
        },
        {
          label: 'Logout At',
          key: 'logoutAt',
          type: 'time'
        }
      ]
    }
    let { visible } = this.state
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Edit Attendence
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={300}
        visible={visible}>
        <Card>
          <Form onSubmit={this.handleEditAttendenceSubmit} style={{ marginTop: 8 }}>
            <div>
              <GetAllFormFields
                apiurl={API_URL}
                inputSchema={inputTypes}
                getFieldDecorator={getFieldDecorator}
              />
            </div>
            <Row style={{ marginTop: '20px' }}>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>

      </Drawer>
    )
  }
}

@Form.create()
class RegulariseTeamAttendence extends Component {
  state = {
    visible: true,
    record: {},
    showEditAttendenceDrawer: false,
    loading: false
  }


  handleSubmit = (e) => {
    e.preventDefault();
    const { form, regulariseData } = this.props;
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);
        let staffIds = [];
        _.each(regulariseData.usersData, (item) => {
          staffIds.push(item._id);

          // staffIds.push({ _id: item._id, attendanceDate: item.attendanceDate })
        })
        let dataToSend = {
          values: values,
          staffIds: staffIds
        }

        this.setState({ loading: true })
        let response = await Request.updateSelectedStaffAttendence(dataToSend)
        this.setState({ loading: false })
        if (response.success) {
          notification.success({
            message: response.message
          })
          this.onClose()
        }
      } else {
        notification.error({
          message: 'Something Went Wrong'
        })
      }
    })
  }


  setFormFields = () => {
    const { regulariseData, form } = this.props;

    // let date  = regulariseData.usersData[0].attendanceDate

    //   setTimeout(() => {
    //     form.setFieldsValue({
    //      attendanceDate:moment(date)
    //     })
    //  }, 500)
  }

  onClose = () => {
    setTimeout(() => {
      this.props.onClose()
    }, 400)
  }

  componentDidMount() {
    this.setFormFields()
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue }
    } = this.props
    const { visible } = this.state
    const inputTypes = {
      fields: [
        {
          label: 'Start Time',
          key: 'loginAt',
          type: 'time',
          format: 'HH:MM:SS',
          required: true,
        },
        {
          label: 'End Time',
          key: 'logoutAt',
          type: 'time',
          required: true,
        },
        {
          label: 'Reason',
          key: 'updateReason',
          type: 'text',
          required: true,
        }
      ]
    }
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Regularise Select User Attendence
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={600}
        visible={visible}>
        <Card>
          <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
            <div>
              <GetAllFormFields
                apiurl={API_URL}
                inputSchema={inputTypes}
                getFieldDecorator={getFieldDecorator}
              />
            </div>
            <Row style={{ marginTop: '20px' }}>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.state.loading}>
                  SAVE
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>

      </Drawer>
    )
  }
}

class AllStaffLoginHistory extends Component {
  state = {
    id: '',
    total: 0,
    defaultPageSize: 50,
    showEditAttendenceDrawer: false,
    allUsers: [],
    userId: '',
    record: {},
    attendenceRecord: {},
    showEditDrawer: false,
    userCheckBox: {},
    addAttendence: false,
    showTeamRegularisationForm: false,
    userAttendence: [],
    regulariseData: [],
    exportLoading: false,
    time: {
      from: moment().startOf('month').toDate(),
      to: moment().endOf('month').toDate(),
    },


  }


  chooseRangerPicker = (date) => {
    if (!date || !date.length) {
      this.setState(
        {
          time: {
            from: moment().startOf('month').toDate(),
            to: moment().endOf('month').toDate(),
          },
        },
        () => this.reload()
      );
      return;
    }

    this.setState(
      {
        time: {
          from: moment(date[0]).startOf('day').toDate(),
          to: moment(date[1]).endOf('day').toDate(),
        },
      },
      () => this.reload()
    );
  };



  onOk = value => {
    this.reload()
  }
  reload = () => {
    this.table.current.reload();
  };
  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })

      if (this.state.userId) {
        params.userId = this.state.userId;
      }
      if (this.state.time && this.state.time.from) {
        params.time = this.state.time;
      }

      params.results = this.state.defaultPageSize;
      let data = await Request.getStaffAttendance({
        ...params
      });
      let employeesCheckBox = {}
      async.each(data.data, (dataItem) => {
        if (!employeesCheckBox[dataItem._id._id]) {
          employeesCheckBox[dataItem._id._id] = {
            _id: dataItem._id._id,
            isChecked: false
          }
        }
      });
      // async.each(data.data, (dataItem) => {
      //   if (!employeesCheckBox[dataItem._id.userId]) {
      //     employeesCheckBox[dataItem._id.userId] = {
      //       userId: dataItem._id.userId,
      //       attendanceDate: dataItem._id.attendanceDate,
      //       isChecked: false
      //     }
      //   }
      // });
      userCheckBox = employeesCheckBox
      let userArray = [];
      if (data.allUsers) {
        data.allUsers.map((user, index) => {
          userArray.push({
            _id: user._id,
            display: user.name
          })
        })
      }
      this.setState({ total: data.total, allUsers: userArray, userCheckBox: userCheckBox })
      resolve(data)
    })
  }

  handleEdit = (record) => {
    this.setState({ showEditDrawer: true, attendenceRecord: record })
  }

  handleDelete = async (record) => {
    let response = await Request.getUserAttendenceReports(record)
    this.setState({ employeeRecord: record, showAttendenceDeleteDrawer: true, userAttendence: response.doc })
  }

  handleAdd = () => {
    this.setState({ addAttendence: true })
  }

  closeEditForm = () => {
    this.setState({ showEditDrawer: false, attendenceRecord: {}, addAttendence: false, showTeamRegularisationForm: false });
    this.table.current.reload()
  }

  componentDidMount() {
    let searchParams = new URLSearchParams(this.props.search);
    let userId = searchParams.get("id");
    let yearMonth = searchParams.get("yearMonth");
    const currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth();
    if (yearMonth) {
      let yearMonthSaparated = yearMonth.split('-');
      year = yearMonthSaparated[0];
      month = yearMonthSaparated[1];
    }
    const actualDate = `${year}-${month}-01`;
    this.setState(
      {
        time: {
          from: moment(actualDate).startOf('month').toDate('1'),
          to: moment(actualDate).endOf('month').toDate(),
        },
        userId: userId
      },
      () => {
        this.reload();
      }
    );
  }

  onClose = () => {
    this.setState({ showAttendenceDeleteDrawer: false }, () => {
      this.table1.current.reload()
      this.table.current.reload()
    })
  }

  handleAttendenceDelete = async (recordId) => {
    let response = await Request.deleteAttendence({ _id: recordId })
    if (response.success) {
      notification.success({
        message: response.message
      })
    }
    this.onClose()
  }

  selectUser = (item, studentId) => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  handleAllRegularisations = () => {
    let userArr = _.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      regulariseData = {
        usersData: userArr,
      }
      this.setState({ showTeamRegularisationForm: true, regulariseData: regulariseData })
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  }

  handleExport = async () => {
    let params = { time: this.state.time }
    if (this.state.userId) {
      params.userId = this.state.userId
    }
    this.setState({ exportLoading: true })
    let response = await Request.exportStaffAttendance(params)
    this.setState({ exportLoading: false })
    if (response && response.success) {
      window.open(response.url)
    } else {
      notification.error({
        message: (response && response.message) || 'Something Went Wrong'
      })
    }
  }

  async componentDidMount() {

  }

  closeAttendenceEditForm = () => {
    this.setState({ showEditAttendenceDrawer: false, record: {} }, () => {
      this.table1.current.reload()
    })
  }

  handleAttendenceEdit = (record) => {
    this.setState({ record: record, showEditAttendenceDrawer: true })
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.table1 = React.createRef()
  }

  render() {
    const { total, showTeamRegularisationForm, showEditAttendenceDrawer, record, defaultPageSize, userCheckBox, allUsers, showEditDrawer, attendenceRecord, addAttendence } = this.state;
    const attendanceColumns = [
      {
        title: 'Attendance Date',
        key: 'attendanceDate',

      },
      {
        title: 'Login At',
        key: 'loginAt'
      },
      {
        title: 'Logout At',
        key: 'logoutAt'
      },
      {
        title: 'Working Hours',
        key: 'workingHours'
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={"staffLoginHistory.edit"}>
              <Tooltip title="Click To Edit Attendence">
                <Button
                  shape="circle"
                  onClick={() => this.handleAttendenceEdit(record)}
                  size={"small"}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={"staffLoginHistory.delete"}>
              <Tooltip title="Click To Delete Attendence">
                <Popconfirm title={`Are you Sure to Delete ${record.workingHours} Attendence`} onConfirm={() => this.handleAttendenceDelete(record._id)}>
                  <Button
                    shape="circle"
                    size={"small"}
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    const columns = [
      {
        title: 'User Name',
        key: 'userId',
        dataIndex: 'userId',
        render: (text, record) => (
          <div> {record && record.user && record.user.name} </div>
        )
      },
      {
        title: 'Attendance Date',
        key: 'attendanceDate',
        render: (text, record) => (
          <div> {moment(record._id.attendanceDate).format('DD-MM-YYYY (ddd)')} </div>
        )
      },
      {
        title: 'Total Worked',
        key: 'totalHours',
        render: (text, record) => {
          text = parseFloat(text);
          if (text >= 8.15) {
            return (
              <div style={{ background: 'yellow' }}> Hours:- {text.toFixed(2)} </div>
            )
          } else if (text <= 7.45) {
            return (
              <div style={{ background: 'red', color: 'white' }}> Hours:- {text.toFixed(2)} </div>
            )
          } else {
            return (
              <div style={{ background: 'green', color: 'white' }}> Hours:- {text.toFixed(2)} </div>
            )
          }
        }
      },
      {
        title: 'Total Login Attemtps',
        key: 'totalAttempts',
        render: (text, record) => (
          <div> Count:- {text} </div>
        )
      },
      {
        title: 'Logs (login - logout)',
        key: 'loginAt',
        render: (text, record) => {
          const { loginAt, notLogoutReasons } = record;
          let loginHtml = loginAt.join(' <br /> ');
          return (
            <div>
              <div dangerouslySetInnerHTML={{ __html: loginHtml }}></div>
              {notLogoutReasons && notLogoutReasons.length > 0 ? (
                <div>
                  {notLogoutReasons.map((reason, index) => (
                    <small key={index} style={{ background: 'red', color: '#fff', display: 'block', marginTop: '5px', padding: '2px 5px' }}>
                      {reason}
                    </small>
                  ))}
                </div>
              ) : null}
            </div>
          )
        }
      },
      {
        title: "Action",
        key: "operation",
        dataindex: "operation",
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={"staffLoginHistory.add"}>
              <Tooltip title="Click To Add Attendence">
                <Button
                  shape="circle"
                  size={"small"}
                  icon="plus"
                  onClick={() => this.handleEdit(record)}
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={"staffLoginHistory.add"}>
              <Checkbox key={record._id._id}
                checked={
                  userCheckBox[record._id._id] ? userCheckBox[record._id._id].isChecked : false
                }
                onChange={(y) => {
                  this.selectUser(y, record._id._id);
                }}
              />
            </RightsWrapper>
            <RightsWrapper myRight={"staffLoginHistory.delete"}>
              <Tooltip title="Click To Edit or Delete Attendence">
                <Popconfirm title="Are You Sure?" onConfirm={() => this.handleDelete(record._id)}>
                  <Button
                    shape="circle"
                    size={"small"}
                    icon="edit"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        ),
      },
    ]

    return (
      <PageHeaderWrapper title={`Staff Login History: ${total} `}>
        {
          showEditDrawer ?
            <EditAttendence oldAttendence={attendenceRecord} onClose={this.closeEditForm} />
            : null
        }
        {
          addAttendence ?
            <AddAttendence allUsers={this.state.allUsers} userId={this.state.userId ? this.state.userId : null} onClose={this.closeEditForm} />
            : null
        }
        {
          showTeamRegularisationForm ?
            <RegulariseTeamAttendence regulariseData={regulariseData} onClose={this.closeEditForm} />
            : null
        }
        {
          showEditAttendenceDrawer ?
            <EditAttendenceRecord record={record} onClose={this.closeAttendenceEditForm} />
            : null
        }
        <Card bordered={true}>
          <Row>
            <Col span={8}>
              <label>Search By Date</label><br />
              <RangePicker
                value={[
                  moment(this.state.time.from),
                  moment(this.state.time.to)
                ]}
                format="YYYY-MM-DD"
                placeholder={['Start Date', 'End Date']}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              />
              {/* <RangePicker
                defaultValue={[moment(this.state.time.from), moment(this.state.time.to)]}
                format="YYYY-MM-DD"
                placeholder={['Start Date', 'End Date']}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              /> */}
            </Col>
            <Col span={8}>
              <label>Search by User</label>
              <Select
                allowClear
                showSearch={true}
                style={{ width: '90%' }}
                value={this.state.userId}
                placeholder="Select Option"
                optionFilterProp="name"
                onChange={userId => {
                  this.setState(
                    {
                      userId: userId && userId.toString()
                    },
                    () => {
                      setTimeout(() => {
                        this.reload()
                      }, 500);
                    }
                  );
                }}
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}>
                {
                  allUsers.map((val, idn) => {
                    return (
                      <Option key={idn} value={val._id}>
                        {val.display}
                      </Option>
                    )
                  })
                }
              </Select>
            </Col>
            <Col span={2}>
              <div style={{ textAlign: 'right', marginTop: '15px' }}>
                <RightsWrapper myRight={"staffLoginHistory.add"}>
                  <Button onClick={() => this.handleAdd()}>Add</Button>
                </RightsWrapper>
              </div>
            </Col>
            <Col span={2} style={{ marginLeft: '10px', textAlign: 'center', fontWeight: '600' }}>
              <div style={{ background: 'yellow', padding: '3px', marginTop: '1px' }}>Overtime</div>
              <div style={{ background: 'Red', color: 'white', padding: '3px', marginTop: '2px' }}>Less Time</div>
              <div style={{ background: 'green', color: 'white', padding: '3px', marginTop: '2px' }}>Normal</div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <RightsWrapper myRight={"staffLoginHistory.add"}>
                <Button onClick={() => this.handleAllRegularisations()}>Regularise</Button>
              </RightsWrapper>
              <RightsWrapper myRight={"staffLoginHistory.view"}>
                <Button style={{ marginLeft: '10px' }} icon="download" loading={this.state.exportLoading} onClick={() => this.handleExport()}>Export</Button>
              </RightsWrapper>
            </Col>
          </Row>
        </Card>
        <Card bordered={true} >
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: defaultPageSize,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
        <Drawer title='Delete User Attendence'
          placement="right"
          closable={true}
          onClose={() => this.onClose()}
          visible={this.state.showAttendenceDeleteDrawer}
          width={700}>
          <TableComp ref={this.table1}
            columns={attendanceColumns}
            dataSource={this.state.userAttendence} />
        </Drawer>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  search: router.location.search,
  currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllStaffLoginHistory);

